// extracted by css-extract-rspack-plugin
export default {"label":"TemporalUnitSettings-module__label___E7H0a"};